import { render, staticRenderFns } from "./paned-cards.vue?vue&type=template&id=b16bc7d0&scoped=true&"
import script from "./paned-cards.vue?vue&type=script&lang=js&"
export * from "./paned-cards.vue?vue&type=script&lang=js&"
import style0 from "./paned-cards.vue?vue&type=style&index=0&id=b16bc7d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b16bc7d0",
  null
  
)

export default component.exports